import { useFormaliteService } from '@europrocurement/l2d-domain';
import { CollectionOpenSearchJsonldOpensearchCollectionClientRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type OrderClient = CollectionOpenSearchJsonldOpensearchCollectionClientRead &
    Record<string, unknown>;

const useOrderClient = () => {
    const { collectionOpenSearchApi } = useFormaliteService();
    let searchClientTimeout: number | undefined;

    const searchOrderClient = (term: string): Promise<Array<OrderClient>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchClientTimeout);
            const requestParameters = { q: term || undefined };

            searchClientTimeout = setTimeout(() => {
                collectionOpenSearchApi
                    .apiOpensearchCollectionsClientsGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<OrderClient>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchOrderClient };
};

export default useOrderClient;
